import { userStorage } from "features/auth/AuthUtils";
import LogRocket from "logrocket";
import { AppConfig } from "shared/config/AppConfig";
import { logRocketIdentify } from "shared/utils/LogRocketUtils";

export const appInitLogRocket = () => {
  if (AppConfig.logRocket) {
    LogRocket.init(AppConfig.logRocket.appId, {
      network: {
        requestSanitizer: (request) =>
          // ignore all requests that are not to the API
          // without this the SDK gets overwhelmed by all the requests
          // to load unbundled component files during development
          request.url.startsWith("/api") ? request : null,
      },
    });
    const userData = userStorage.get();
    if (userData) {
      logRocketIdentify(
        userData.userId,
        userData.email,
        userData.firstName,
        userData.lastName,
      );
    }
  }
};
